import { SettingsIntegrationBase } from '@app/models/company/settings/integrations/integration-base.model';

export class IntegrationGreenhouse extends SettingsIntegrationBase {
    protected static _type = 'greenhouses';

    protected static _resource = 'companyManagement/companies/:company/integrations/greenhouse';
}
